import Layout from '../app/Layout';
import Programme from '../pages/Programme/Programme';
import NavbarController from '../components/sections/Navbar/NavbarController';

export default function bootstrapProgramme() {

    const app = document.getElementById('programme-app');

    if (!app) {
        return;
    }

    app.innerHTML = Layout(
        Programme()
    );

    NavbarController();

}
